import React, { useState } from 'react';
import CertificateForm from './CertificateForm';
import CertificateList from './CertificateList';

const VALID_EMAIL = 'missalona90@gmail.com';
const VALID_HASH = '33709a4e7ff2052b58a933f35fc2fc04988103cabbe3bd4337e68bdac39b1832';

async function hashPassword(password) {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

const CertificatePage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem('cert_auth') === 'true'
  );
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [certificates, setCertificates] = useState([]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (email.toLowerCase().trim() !== VALID_EMAIL) {
      setError('Невірна пошта або пароль');
      return;
    }

    const hash = await hashPassword(password);
    if (hash !== VALID_HASH) {
      setError('Невірна пошта або пароль');
      return;
    }

    sessionStorage.setItem('cert_auth', 'true');
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('cert_auth');
    setIsAuthenticated(false);
  };

  const handleCertificateGenerated = (cert) => {
    setCertificates(prev => [cert, ...prev]);
  };

  if (!isAuthenticated) {
    return (
      <div className="cert-page">
        <div className="cert-login-wrapper">
          <div className="cert-login-card">
            <h2>ALENA.BOTOX</h2>
            <p>Генератор сертифікатів</p>
            <form onSubmit={handleLogin}>
              <div className="cert-field">
                <label>Пошта</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="email@gmail.com"
                  required
                />
              </div>
              <div className="cert-field">
                <label>Пароль</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Пароль"
                  required
                />
              </div>
              {error && <div className="cert-error">{error}</div>}
              <button type="submit" className="cert-btn">Увійти</button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cert-page">
      <div className="cert-dashboard">
        <div className="cert-header">
          <h2>ALENA.BOTOX — Сертифікати</h2>
          <button onClick={handleLogout} className="cert-btn-logout">Вийти</button>
        </div>
        <CertificateForm onGenerated={handleCertificateGenerated} />
        <CertificateList certificates={certificates} />
      </div>
    </div>
  );
};

export default CertificatePage;
